let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6knr6")).then(() => parcelRequire('i5Nvt'));